import { setPlannerNameList } from "../redux/slices/PlannerListSlice";
import { getData } from "../webService/webService";
export const fetchAllPlanner = async (dispatch, accessToken) => {
  try {
    const res = await getData(
      "masters/user/basic/nameandid/Planner",
      null,
      accessToken
    );
    if (res.status === 200) {
      dispatch(setPlannerNameList(res.data));
      console.log(res.data);
    }
  } catch (error) {
    console.error("Error:", error);
  }
};
